<template>
	<div v-if="renderAsList" class="row mb-2 diff-file">
		<div class="col-2 btn-group-container" role="group">	   
			<slot name="options"></slot>
		</div>

		<div class="col">
			<slot name="folder"></slot>
		</div>

		<div class="col d-flex justify-content-between pl-0">
			<slot name="file"></slot>
			<slot name="diff"></slot>
		</div>
	</div>
	<tr v-else class="diff-file-row">
		<td class="btn-group-container">
			<slot name="options"></slot>
		</td>
		<td>
			<slot name="folder"></slot>
		</td>
		<td>
			<slot name="file"></slot>
		</td>
		<td>
			<div class="float-right">
				<slot name="diff"></slot>
			</div>
		</td>
	</tr>
</template>

<script>

export default {
	name: "GitDiffFileContainer",
	props: ['renderAsList'],
	components: {
	},
	data() {
		return {
		}
	},
	methods: {
	}
}
</script>

<style scoped>
	.diff-file-row:focus-within {
		background-color: #f1d297;
	}
</style>